export let PricingActionTypes;

(function (PricingActionTypes) {
  PricingActionTypes["FetchProducts"] = "[Pricing] Fetch Products";
  PricingActionTypes["FetchPromotions"] = "[Pricing] Fetch Promotions";
  PricingActionTypes["UpdateProductsResponse"] = "[Pricing] Update Products Response";
  PricingActionTypes["UpdatePromotionsResponse"] = "[Pricing] Update Promotions Response";
  PricingActionTypes["UpdateCurrencyCode"] = "[Pricing] Update Currency Code";
  PricingActionTypes["UpdateRequiredOnboarding"] = "[Pricing] Update Required Onboarding";
  PricingActionTypes["UpdateDtbId"] = "[Pricing] Update Dtb Id";
})(PricingActionTypes || (PricingActionTypes = {}));